import { Box, Typography } from "@material-ui/core"
import NextLink from "components/Reusable/Bit/NextLink"
import styled from "styled-components"
import CompaniesPhoneIcon from "../../components/Icons/CompaniesPhoneIcon"
import CompaniesWhatsappIcon from "../../components/Icons/CompaniesWhatsappIcon"

const StyledBottomWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  padding-bottom: 30px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 20px;

    padding-bottom: 0px;
  }
  a {
    margin-left: 20px;
    :hover {
      text-decoration: underline;
    }
  }
`

const StyledIconWrapper = styled(Box)`
  p {
    font-weight: bold;
    margin-bottom: 0px;
    margin-right: 7px;
  }
  display: flex;
  align-items: center;
`

const StyledSubtitle = styled(Typography).attrs({ variant: "body1" })`
  text-align: right;
  margin-bottom: 37px;
`

const StyledBottomText = styled(Typography).attrs({ variant: "h2" })`
  text-align: right;
  margin-top: 60px;
  margin-bottom: 20px;
  font-size: 26px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: 27px;
    margin-bottom: 0px;
  }
`

type SocialSectionProps = {
  phone: string
  whatsapp: string
}

const SocialSection = ({ phone, whatsapp }: SocialSectionProps) => {
  return (
    <>
      <StyledBottomText>רוצה לדבר איתנו כבר עכשיו?</StyledBottomText>
      <StyledBottomWrapper>
        <NextLink
          href={`tel:${phone}`}
          aria-label="דברו איתנו כבר עכשיו בטלפון"
        >
          <StyledIconWrapper>
            <CompaniesPhoneIcon />
            <StyledSubtitle>{phone}</StyledSubtitle>
          </StyledIconWrapper>
        </NextLink>
        <NextLink
          href={whatsapp}
          openInNewTab
          ariaLabel=" דברו איתנו כבר עכשיו באמצעות הוואטסאפ"
        >
          <StyledIconWrapper>
            <CompaniesWhatsappIcon />
            <StyledSubtitle>וואטסאפ</StyledSubtitle>
          </StyledIconWrapper>
        </NextLink>
      </StyledBottomWrapper>
    </>
  )
}

export default SocialSection
